import axios from 'axios'
// import axios from './http'
import userService from '@/services/user'
import Vue from 'vue'
//axios.defaults.timeout = 30000
export default {
    state: {
        getUrl() {
            const instance = axios.create({
                // baseURL: 'http://localhost:3000'
                //baseURL: (process.env.NODE_ENV ==='production')?'http://10.2.210.211:30308':'http://localhost:3000'
                // baseURL: 'http://10.2.210.211:30308'
                baseURL: Vue.config['url']
            });
            //instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
            instance.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
            instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
            return instance
        }
    },
    getDiscount(dataSearch) {
        /* var search = "";
         if(dataSearch){
             search = "/?type="+dataSearch.type+"&keyword="+dataSearch.keyword+"&start="+((dataSearch.start) ? dataSearch.start : 0 )+"&limit="+((dataSearch.limit)? dataSearch.limit : 10);
         } */
        let emp_code = Vue.$jwt.decode(localStorage.getItem('token')).code;
        var search = "/?type=" + ((dataSearch.type) ? dataSearch.type : "") + "&keyword=" + ((dataSearch.keyword) ? encodeURIComponent(dataSearch.keyword) : "") + "&start=" + ((dataSearch.start) ? dataSearch.start : 0) + "&limit=" + ((dataSearch.limit) ? dataSearch.limit : 20) + "&username=" + ((dataSearch.username) ? dataSearch.username : '');
        search += '&emp_code=' + ((emp_code) ? emp_code : "")
        return axios.get('/v1/pricing/discount/list' + search)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });

    },
    getDiscountDetail(value) {

        return axios.get('/v1/pricing/discount-details/' + value)
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error);
            });
    },
    saveDiscount(discount) {
        // console.log(discount);
        return axios.post('/v1/pricing/discount/list', discount)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    saveImport(data, effective_date) {
        return axios.post('/v1/pricing/pricelist', {
                data: data,
                effective_date: effective_date
            })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getProduct(datas) {
        return axios.post('/v1/pricing/product', {
                pro_code: datas
            })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getProductsPrice(datas) {
        //let datas = ['FI525606','121389'];
        return axios.post('/v1/pricing/discount/price-product', {
                pro_code: datas
            })
            .then(function (response) {
                // console.log(response);
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },

    getPriceList(tab_type, dataSearch, type_export, cancelToken) {
        /* var search = "/?type="+tab_type;
        if(dataSearch){
            search = "/?type="+tab_type+"&keyword="+((dataSearch.keyword) ? dataSearch.keyword : "" )+"&start="+((dataSearch.start) ? dataSearch.start : 0 )+"&limit="+((dataSearch.limit)? dataSearch.limit : 10);
        } */
        // var search = "/?type="+tab_type+"&keyword="+((dataSearch.keyword) ? dataSearch.keyword : "" )+"&start="+((dataSearch.start) ? dataSearch.start : 0 )+"&limit="+((dataSearch.limit)? dataSearch.limit : 20);
        var search = "/?tab=" + tab_type + "&keyword=" + ((dataSearch.keyword) ? dataSearch.keyword : "") +
            //"&access=" + ((dataSearch.access) ? dataSearch.access : "") +
            "&emp_code=" + ((dataSearch.emp_code) ? dataSearch.emp_code : "") +
            "&search=" + ((dataSearch.search) ? dataSearch.search : "") +
            "&type=" + ((dataSearch.type) ? dataSearch.type : "") +
            "&group=" + ((dataSearch.group) ? dataSearch.group : "") +
            "&sub_group=" + ((dataSearch.subGroup) ? dataSearch.subGroup : "") +
            "&cg=" + ((dataSearch.cg) ? dataSearch.cg : "") +
            "&m=" + ((type_export) ? type_export : "") +
            "&start=" + ((dataSearch.start) ? dataSearch.start : 0) +
            "&limit=" + ((dataSearch.limit) ? dataSearch.limit : 20);

        return axios.get('/v1/pricing/pricelist' + search, {
                cancelToken: cancelToken // เพิ่ม CancelToken เข้าไปใน request
            })
            // return axios.post('/v1/pricing/pricelist', 
            //         {
            //             tab: tab_type, 
            //             keyword: ((dataSearch.keyword) ? dataSearch.keyword : "" ),
            //             type: ((dataSearch.type) ? dataSearch.type : "" ),
            //             group: ((dataSearch.group) ? dataSearch.group : "" ),
            //             sub_group: ((dataSearch.subGroup) ? dataSearch.subGroup : "" ),
            //             cg: ((dataSearch.cg) ? dataSearch.cg : "" ),
            //             start: ((dataSearch.start) ? dataSearch.start : 0 ),
            //             limit: ((dataSearch.limit)? dataSearch.limit : 20)
            //         })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                if (axios.isCancel(error)) {
                    // console.log('Request canceled:', error.message);
                }
                return Promise.reject(error);
            });
    },
    async exportPriceList(dataSearch) {
        let user = Vue.$jwt.decode(localStorage.getItem('token'));
        var user_db;
        await userService.getInfo(user.id)
            .then((response) => {
                //console.log("response ==>", response);
                user_db = response;
            })

        var search = "/?tab=" + dataSearch.tab + "&keyword=" + ((dataSearch.keyword) ? dataSearch.keyword : "") +
            "&search=" + ((dataSearch.search) ? dataSearch.search : "") +
            "&type=" + ((dataSearch.type) ? dataSearch.type : "") +
            "&group=" + ((dataSearch.group) ? dataSearch.group : "") +
            "&sub_group=" + ((dataSearch.subGroup) ? dataSearch.subGroup : "") +
            "&cg=" + ((dataSearch.cg) ? dataSearch.cg : "") +
            "&user_email=" + ((user_db.email) ? user_db.email : "") +
            "&emp_code=" + ((dataSearch.emp_code) ? dataSearch.emp_code : "");

        return axios.get('/v1/pricing/expory-pricelist' + search)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });
    },
    async checkDataImport() {
        let user = Vue.$jwt.decode(localStorage.getItem('token'));
        var user_db;
        await userService.getInfo(user.id)
            .then((response) => {
                user_db = response;
            })

        var dataImport = "/?user_email=" + ((user_db.email) ? user_db.email : "");
        return axios.get('/v1/pricing/check-data-import' + dataImport)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });
    },
    importPriceList(data) {
        var dataImport = "/?id=" + ((data.id) ? data.id : "") + "&eff_date=" + ((data.eff_date) ? data.eff_date : "");
        return axios.get('/v1/pricing/import-pricelist' + dataImport)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });
    },
    deleteFilePriceList(idFile) {
        var fileDelete = "/?id=" + ((idFile) ? idFile : "");
        return axios.get('/v1/pricing/delete-file-pricelist' + fileDelete)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });
    },

    getPricingLog(code) {
        let emp_code = Vue.$jwt.decode(localStorage.getItem('token')).code;
        return axios.get('/v1/pricing/pricelog/?code=' + code + '&emp_code=' + emp_code)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                // console.log(error);
                return Promise.reject(error);
            });
    },

    deleteDiscount(_id) {
        return axios.delete('/v1/pricing/discount/list/?_id=' + _id)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    countPricingList() {
        return axios.get('/v1/pricing/count-pricelist')
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    ProductTree(code, type, dataDelete, emp_code = undefined, typeSearch, datas) {
        var dataSearch = {};
        if (typeSearch == "popup") {
            dataSearch = {
                has_stock: true,
                pro_code: (code) ? code : '',
                type: type,
                data_delete: dataDelete,
                emp_code: emp_code,
                name: (datas.name) ? datas.name : '',
                group: (datas.group) ? datas.group : '',
                subgroup: (datas.subgroup) ? datas.subgroup : '',
                cg: (datas.cg) ? datas.cg : ''
            }
        } else {
            dataSearch = {
                has_stock: true,
                pro_code: code,
                type: type,
                data_delete: dataDelete,
                emp_code: emp_code,
                name: '',
                group: '',
                subgroup: '',
                cg: ''
            }
        }
        return axios.post('/v1/pricing/search-product', dataSearch)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    GetTypeAllProduct() {
        return axios.get('/v1/pricing/get-type-all-product')
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    FilterProducts(arrFilter) {
        return axios.post('/v1/pricing/filter-product', {
                arrFilter: arrFilter
            })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    GetFilterProducts(arrFilter) {
        return axios.post('/v1/pricing/get-filter-product', {
                arrFilter: arrFilter
            })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getListItems(items) {
        let emp_code = Vue.$jwt.decode(localStorage.getItem('token')).code;
        return axios.post('/v1/pricing/get-list-items', {
                items: items,
                emp_code: emp_code
            })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getAllProduct(datas) {
        var type = (datas && datas.type) ? datas.type : '';
        var code = (datas && datas.code) ? datas.code : '';
        return axios.get('/v1/pricing/product-hierarchy?type=' + type + '&code=' + code)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getAllProductSearch(datas) {
        var group = (datas && datas.group) ? datas.group : '';
        var subgroup = (datas && datas.subgroup) ? datas.subgroup : '';
        var cg = (datas && datas.cg) ? datas.cg : '';
        var code = (datas && datas.code) ? datas.code : '';
        var name = (datas && datas.name) ? datas.name : '';
        return axios.get('/v1/pricing/product-search?code=' + encodeURIComponent(code) + '&name=' + encodeURIComponent(name) + '&group=' + encodeURIComponent(group) + '&subgroup=' + encodeURIComponent(subgroup) + '&cg=' + encodeURIComponent(cg))
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getAllVD() {
        return axios.get('/v1/pricing/get-all-voldiscount')
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    ReportList(datas) {
        // return this.state.getUrl().post('/v1/pricing/report-list', datas)
        return axios.post('/v1/pricing/report', datas)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    ReportChart(datas) {
        return axios.post('/v1/pricing/report-chart', datas)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    ReportExportItem(datas) {
        return axios.post('/v1/pricing/report-export-item', datas)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    getAllProductGroup(datas) {
        return this.state.getUrl().post('/v1/pricing/search-product', datas)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    filterVD(datas) {
        var prodgroup = (datas && datas.prodgroup) ? datas.prodgroup : '';
        return axios.get('/v1/pricing/filter-voldiscount?prodgroup=' + prodgroup)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    showPoint(value, pos) {
        if (isNaN(parseFloat(value))) {
            return value;
        } else {
            let rs = 0;
            if (value % 1 == 0) {
                rs = parseFloat(value).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            } else {
                let parts = value.toString().split(".");
                let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                let digit = parts[1].slice(0, 2);
                digit = (digit.length < 2) ? digit + "0" : digit;
                rs = num + "." + digit;
            }
            var result = rs.split(".");
            if (pos == "front") {
                return result[0];
            } else {
                return "." + result[1];
            }
        }
    },
    formatNumber(value, dicimal) {
        if (isNaN(parseFloat(value))) {
            return value;
        } else {
            if (value % 1 == 0) {
                return parseFloat(value).toLocaleString(undefined, {
                    minimumFractionDigits: dicimal,
                    maximumFractionDigits: dicimal
                });
            } else {
                let parts = value.toString().split(".");
                let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                let rs = num;
                if (parts.length > 1) {
                    let digit = parts[1].slice(0, 3);
                    digit = (digit.length < 2) ? digit + "0" : digit;
                    rs = num + "." + digit;
                }
                let comma = parseFloat(rs.replace(',', ''));
                // return Math.round(parseFloat(comma) * 100) / 100;
                return parseFloat(Math.round(parseFloat(comma) * 100) / 100).toLocaleString(undefined, {
                    minimumFractionDigits: dicimal,
                    maximumFractionDigits: dicimal
                });
            }
        }
    },
}